<template>
  <div class="contracts">
    <div class="title">
      <b>{{list.length && list[0].name}}的合同管理</b>
    </div>
    <a-table
      :columns="columns"
      :dataSource="list"
      class="hunter-table"
      :pagination="pagination"
      :loading="loading"
      rowKey="id"
    >
      <span slot="info" slot-scope="text, record">
        合同类型：{{ record.type == "PERSONAL" ? "个人签约" : "猎企签约" }}
        <br />
        合同ID：{{ record.id }} <br />合同甲方：{{ record.parta_person_name }} <br />合同乙方：{{ record.name }}
      </span>
      <span slot="signing_info" slot-scope="text, record">
        合同周期：{{ record.start_time }}-{{ record.end_time }}
        <br />
        佣金比例：{{ Number(record.additional_allowance_ratio) + 50 }} <br />备注：
      </span>
      <span slot="examine" slot-scope="text, record">
        审核时间：{{ record.auditor_at }}
        <br />
        审核人：{{ record.auditor_by_name }}
      </span>
      <span slot="enclosure" slot-scope="text, record">
        <span v-for="(item, i) in record.attachments" :key="i">
          {{
            item.type == "1"
              ? "身份证正面："
              : item.type == "2"
              ? "身份证反面："
              : item.type == "3"
              ? "电子签章："
              : "合同附件："
          }}
          <a @click="attachmentsDetail(item.file_url)">{{ item.file_name }}</a>
          <br />
        </span>
      </span>
      <span slot="action" slot-scope="record" class="action">
        <span v-if="record.status === 'PENDING'">
          <a @click="$refs.contractPassModal.show(record.id)">审核通过</a>&nbsp;
          <a href="javascript:;" @click="() => refuse(record.id)">审核不通过</a
          >&nbsp;
        </span>
        <span v-if="record.status === 'PASSED'">已审核通过</span>
        <span v-if="record.status === 'REJECT'">已拒绝</span>
      </span>
    </a-table>
    <a-modal v-model="refusalMadel" title="请编辑理由">
      <template slot="footer">
        <a-button key="back" @click="handleRefuseCancel">取消</a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          @click="addRefuseModal"
          >确认</a-button
        >
      </template>
      <div>
        <b>编辑审核不通过理由：</b>
      </div>
      <div style="position: relative">
        <a-textarea
          placeholder="请填写淘汰理由，该条信息将直接反馈给签约用户"
          :rows="4"
          maxlength="50"
          v-model="refusalReasons"
          @change="handleRefusalLength"
        />
        <span class="count">{{ reasonsLength }} / 50</span>
      </div>
    </a-modal>
    <contract-pass-modal
      ref="contractPassModal"
      @ok="getData()"
    ></contract-pass-modal>
  </div>
</template>

<script>
import Api from "@/api";
import ContractPassModal from "./contract-pass-modal";
const columns = [
  {
    title: "合同信息",
    dataIndex: "info",
    key: "info",
    scopedSlots: { customRender: "info" }
  },
  {
    title: "签约信息",
    dataIndex: "signing_info",
    key: "signing_info",
    scopedSlots: { customRender: "signing_info" }
  },
  {
    title: "审核信息",
    dataIndex: "examine",
    key: "examine",
    scopedSlots: { customRender: "examine" }
  },
  {
    title: "合同附件",
    dataIndex: "enclosure",
    key: "enclosure",
    scopedSlots: { customRender: "enclosure" }
  },
  {
    title: "操作",
    key: "action",
    scopedSlots: { customRender: "action" }
  }
];
export default {
  name: "contracts",
  data() {
    return {
      columns,
      loading: false,
      list: [],
      pagination: {
        pageNo: 1,
        size: "small",
        pageSize: 10, // 默认每页显示数量
        showSizeChanger: true, // 显示可改变每页数量
        pageSizeOptions: ["10", "20", "50"], // 每页数量选项
        showTotal: total => `共 ${total} 条`, // 显示总数
        showQuickJumper: true,
        total: 0 //总条数
      },
      adoptYes: false,
      subsidy: null,
      refusalReasons: "",
      refusalMadel: false,
      reasonsLength: "0",
      user_id: "0",
      contractId: ""
    };
  },
  created() {
    this.user_id = this.$route.query.id;
    this.getData();
  },
  mounted() {},
  computed: {},
  components: { ContractPassModal },
  methods: {
    async getData(pagination) {
      this.loading = true;
      if (pagination) {
        let pager = { ...this.pagination };
        pager.current = pagination.current;
        this.pagination = pager;
      } else {
        this.pagination.current = 1;
      }
      let params = {
        user_id: this.user_id,
        page: this.pagination.current,
        limit: this.pagination.pageSize
      };
      let response = await Api.hunter.getContractList(params);
      this.loading = false;
      this.pagination.total = +response.total;
      this.list = response.list;
      console.log(response);
    },
    adopt(id) {
      this.adoptYes = true;
      this.contractId = id;
    },
    refuse(id) {
      this.refusalMadel = true;
      this.contractId = id;
    },
    addAdoptModal() {
      let _this = this;
      if (this.subsidy && Number.isInteger(Number(this.subsidy))) {
        let params = {
          contract_id: this.contractId,
          additional_allowance_ratio: this.subsidy
        };
        console.log(params);
        Api.hunter.acceptContract(params).then(() => {
          _this.adoptYes = false;
          _this.getData();
        });
      } else {
        this.$message.info("请输入正整数");
      }
    },
    addRefuseModal() {
      let _this = this;
      if (this.refusalReasons) {
        let params = {
          contract_id: this.contractId,
          reject_reasons: this.refusalReasons
        };
        console.log(params);
        Api.hunter.rejectContract(params).then(() => {
          _this.refusalMadel = false;
          this.$message.info("审核不通过操作成功！");
          _this.getData();
        });
      } else {
        this.$message.info("请填写理由！");
      }
    },
    handleCancel() {
      this.adoptYes = false;
    },
    handleRefuseCancel() {
      this.refusalMadel = false;
    },
    handleRefusalLength(e) {
      this.reasonsLength = e.target.value.length;
    },
    attachmentsDetail(url) {
      window.open(url, "_blank");
    }
  }
};
</script>

<style scoped lang="scss">
.contracts {
  .title {
    margin-bottom: 15px;
  }
}
.count {
  color: #999;
  position: absolute;
  right: 15px;
  bottom: 10px;
}
</style>
